/**
 * Every control of the app vocabulary beyond the first eighteen nodes: the definitions, the schemas built from them, and the
 * rules that cross properties (exactly one of `rows` and `rowsFrom`).
 * OURS: the workbench defines these files; AIOE mirrors them.
 */
import { z } from "zod";
import { CHART_CONTROLS } from "./charts.js";
import { DISPLAY_CONTROLS } from "./display.js";
import { FORM_CONTROLS } from "./forms.js";
import { makeKit } from "./kit.js";
import { MAP_CONTROLS } from "./map.js";
import { NAVIGATION_CONTROLS } from "./navigation.js";
export { CONTROL_GROUPS, CONTROL_GROUP_TITLES } from "./kit.js";
export { HEROUI_COVERAGE, excludedComponents } from "./coverage.js";
/** In the order the gallery shows them. */
export const CONTROL_DEFS = [...DISPLAY_CONTROLS, ...CHART_CONTROLS, ...FORM_CONTROLS, ...NAVIGATION_CONTROLS, ...MAP_CONTROLS];
export const CONTROL_TYPES = CONTROL_DEFS.map((d) => d.type);
const BY_TYPE = new Map(CONTROL_DEFS.map((d) => [d.type, d]));
export const controlDef = (type) => BY_TYPE.get(type);
export const controlsIn = (group) => CONTROL_DEFS.filter((d) => d.group === group);
/** The strict schemas, one per control; `node` is the lazy schema of any node (for the containers). */
export function controlSchemas(node) {
    const kit = makeKit(node);
    return CONTROL_DEFS.map((d) => z.object({ type: z.literal(d.type), tooltip: kit.label.optional(), ...d.shape(kit) }).strict());
}
/** The things a shape cannot say: a control that takes `rows` or `rowsFrom` takes one. Sentences an agent can act on. */
export function controlProblems(n) {
    const def = BY_TYPE.get(n.type);
    if (!def?.sources)
        return [];
    const out = [];
    for (const [literal, bound] of def.sources) {
        const hasLiteral = n[literal] !== undefined;
        const hasBound = n[bound] !== undefined;
        if (!hasLiteral && !hasBound)
            out.push(`${n.type} needs ${literal} or ${bound}`);
        if (hasLiteral && hasBound)
            out.push(`${n.type} takes ${literal} or ${bound}, not both`);
    }
    return out;
}
//# sourceMappingURL=index.js.map